import React, { useEffect, useState } from "react";
import { useAuth } from "./items/AuthProvider";
import request from "../services/Request";
import { formatAddress } from "../services/method/methods";

const PendingOrder = () => {
  const { user, refresh, setRefresh } = useAuth();

  const [oneMachine, setOneMachine] = useState(null);

  useEffect(() => {
    setRefresh(!refresh);
  }, []);

  const products = user?.add_to_cart?.products;
  const machine = user?.add_to_cart?.machine;

  useEffect(() => {
    if (products && machine) {
      request({
        method: "get",
        url: `/machines/edit/${user?.add_to_cart?.machine._id}`,
      })
        .then((res) => {
          console.log("oneMachine", res.data);
          if (res.data?.address?.street) {
            res.data.addressString = formatAddress(res.data.address);
          } else {
            res.data.addressString = res.data.address.full_address;
          }

          setOneMachine(res.data);
          // setProducts(res.data);
        })
        .catch((err) => {});
    }

    return () => {
      // Cleanup code if needed
      setOneMachine(null);
    };
  }, []);

  return (
    <div className="page-container">
      <h1 className="text-3xl font-bold text-gray-800 mb-4 mt-2">
        My Pending Order
      </h1>
      {products && machine && (
        <div>
          <h1 className="text-2xl font-bold text-gray-800 mb-4 mt-4">
            Machine
          </h1>
          <div className="bg-blue-50 p-3 rounded-md mt-4">
            <p>
              <span className="font-medium">Name:</span> {machine.name}
            </p>
            <p>
              <span className="font-medium">Description:</span>{" "}
              {machine.description}
            </p>
            {oneMachine?.addressString && (
              <p>
                <span className="font-medium">Locations:</span>{" "}
                {oneMachine?.addressString}
              </p>
            )}
          </div>
          <h1 className="text-2xl font-bold text-gray-800 mb-4 mt-4">
            Products
          </h1>

          {products.map((product, index) => (
            <div key={index} className="mb-4 bg-gray-100 p-3 rounded-md">
              <div className="flex items-center mb-2">
                <p className="text-lg font-semibold text-gray-800">
                  Name: {product.id.name.en}
                </p>
              </div>

              {/* <div className="flex items-center">
              <p className="text-gray-700">${product.id.price.toFixed(2)}</p>
            </div> */}

              <div className="flex items-center mt-1">
                <p className="text-gray-700">UPC: {product.id.upc}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PendingOrder;
